export default __webpack_public_path__ + "img/catIcon8.4bc213d4.svg";